var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row no-gutters mb-3"
  }, [_c('div', {
    staticClass: "col-md-4 pr-md-2 mb-2 mb-md-0"
  }, [_c('div', {
    staticClass: "summary-card border rounded px-3 py-3 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "summary-icon mr-3",
    staticStyle: {
      "background": "#C6F8E8",
      "border-radius": "12px",
      "width": "48px",
      "height": "48px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fileIcon)
    }
  })]), _c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("IDR. " + _vm._s(_vm.formatCurrency(_vm.totalBilling)))]), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("Total Billing")])])])]), _c('div', {
    staticClass: "col-md-4 px-md-1 mb-2 mb-md-0"
  }, [_c('div', {
    staticClass: "summary-card border rounded px-3 py-3 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "summary-icon mr-3",
    staticStyle: {
      "background": "#D9E1FF",
      "border-radius": "12px",
      "width": "48px",
      "height": "48px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fileIcon)
    }
  })]), _c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("IDR. " + _vm._s(_vm.formatCurrency(_vm.totalUnpaid)))]), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("Total Unpaid")])])])]), _c('div', {
    staticClass: "col-md-4 pl-md-2"
  }, [_c('div', {
    staticClass: "summary-card border rounded px-3 py-3 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "summary-icon mr-3",
    staticStyle: {
      "background": "#F6D5D5",
      "border-radius": "12px",
      "width": "48px",
      "height": "48px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.fileIcon)
    }
  })]), _c('div', [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("IDR. " + _vm._s(_vm.formatCurrency(_vm.totalPaid)))]), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("Total Paid")])])])])]), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "input": _vm.fetchPaymentLists
    },
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('date-picker', {
    attrs: {
      "range": "",
      "format": "DD/MM/YYYY"
    },
    on: {
      "change": _vm.fetchPaymentLists
    },
    model: {
      value: _vm.period,
      callback: function callback($$v) {
        _vm.period = $$v;
      },
      expression: "period"
    }
  }), _c('b-form-select', {
    staticClass: "ml-2",
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "change": _vm.fetchPaymentLists
    },
    model: {
      value: _vm.status,
      callback: function callback($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  })], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("+ Add Data Payment List")])], 1), _c('div', {
    staticClass: "d-flex overflow-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.value, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-truncate"
    }, [item.shippment_plan ? _c('div', _vm._l(_vm.parsePlans(item.shippment_plan), function (plan, pIdx) {
      return _c('div', {
        key: pIdx
      }, [_vm._v(" " + _vm._s(plan.shipment_plan_detail_number) + " ")]);
    }), 0) : _vm._e()]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v("-")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(item.request_date_start ? _vm.moment(item.request_date_start).format('DD MMM YYYY') : '-'))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(item.request_date_end ? _vm.moment(item.request_date_end).format('DD MMM YYYY') : '-'))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" - ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('b-badge', {
      attrs: {
        "variant": item.status === 'Approved' ? 'success' : item.status === 'Requested' ? 'warning' : 'secondary'
      }
    }, [_vm._v(_vm._s(item.status || 'Requested'))])], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_c('b-button', {
      attrs: {
        "id": "action-popover-payment-list-".concat(index),
        "size": "sm",
        "variant": "outline-primary",
        "tabindex": "0"
      }
    }, [_vm._v(" Action ")]), _c('b-popover', {
      attrs: {
        "target": "action-popover-payment-list-".concat(index),
        "triggers": "focus",
        "placement": "left",
        "custom-class": "action-popover"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('b-button', {
      staticClass: "text-left p-1",
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.edit(index);
        }
      }
    }, [_vm._v(" Edit ")]), _c('b-button', {
      staticClass: "text-left p-1 text-danger",
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.remove(index);
        }
      }
    }, [_vm._v(" Delete ")])], 1)])], 1)]);
  }), 0)])]), _c('CustomSidebar', {
    attrs: {
      "title": "Add Payment List",
      "size": "100%",
      "noCloseOnBackdrop": "",
      "noCloseOnEsc": ""
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? _c('SlidePaymentList', {
    attrs: {
      "action": _vm.sidebarAction,
      "projectId": _vm.projectId,
      "paymentId": _vm.sidebarPaymentId,
      "projectData": _vm.projectData,
      "optionsProjectTerms": _vm.optionsProjectTerms,
      "positionListTextPOD": _vm.positionListTextPOD,
      "positionListTextPOL": _vm.positionListTextPOL,
      "optionsFleetTypes": _vm.fleetTypeOptions,
      "optionsCargoType": _vm.optionsCargoType,
      "fleetOptions": _vm.fleetOptions,
      "refreshData": _vm.refreshData
    },
    on: {
      "close": _vm.closeSidebar,
      "saved": _vm.onSidebarSaved
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Detail Shipment ID")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Real Invoice Number")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Invoice Date")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Due Date")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Invoice File")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Action")])])]);

}]

export { render, staticRenderFns }